var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('views',{staticClass:"empty"},[_c('views',{staticClass:"empty-content"},[_c('views',{staticClass:"desc"},[_c('images',{attrs:{"src":_vm.warn}}),_vm._v(" 没有符合您的抽奖活动 ")],1),_c('button',{on:{"click":_vm.handleHome}},[_vm._v("返回首页")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }